import { z } from "zod";

import { productionOptionSchema } from "./production-option";
import { packagingComponentBaseSchema } from "./packaging-component";
import { packagingSolutionSchema } from "./packaging-solution";
import { packagingSolutionOptionsSchema } from "./packaging-solution-options";
import { locationSchema } from "./location";

export const packagingComponentStagedSchema = packagingComponentBaseSchema.extend({
	id: z.string(),
	productionOptions: z.array(productionOptionSchema),
});

const packagingLabelStagedSchema = packagingComponentStagedSchema.extend({});

const packagingPrintStagedSchema = packagingComponentStagedSchema.extend({});

const packagingCartonStagedSchema = packagingComponentStagedSchema.extend({
	labels: z.array(packagingLabelStagedSchema),
	prints: z.array(packagingPrintStagedSchema),
});

export const packagingSolutionStagedSchema = packagingSolutionSchema.extend({
	licensePlateNumber: z.string().nullish(),
	options: packagingSolutionOptionsSchema,
	priority: z.number(),
	groupIdDate: z.coerce.date(),
	createByDate: z.coerce.date(),
	attributes: z.record(z.string(), z.string()),
	failureReason: z.string().nullish(),
	cartons: z.array(packagingCartonStagedSchema),
	labels: z.array(packagingLabelStagedSchema),
	location: locationSchema,
});

export type StagedLabel = z.infer<typeof packagingLabelStagedSchema>;
export type StagedCarton = z.infer<typeof packagingCartonStagedSchema>;
export type PackagingSolutionStaged = z.infer<typeof packagingSolutionStagedSchema>;
export type PackagingSolutionStagedLocation = z.infer<typeof locationSchema>;
